export default "__VITE_ASSET__Df_DGF4S__"